import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainNavigationHeader = styled.header`
  height: 90px;
  background: var(--sops-bg-white);
  border-bottom: 1px solid #e7e7e7;
  padding: 20px;
`;

const MainNavigationLayoutSideBar = styled.aside`
  position: absolute;
  top: 0px;
  bottom: 0px;
  transition: transform 0.2s ease-out 0s;
  will-change: transform;
  overflow-y: auto;
  height: 100%;
  left: 0px;
  transform: ${(props) =>
    props.hideNavigation ? 'translateX(-100%)' : 'translateX(0%)'};
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  color: #000000;
  padding: 8px;
  border-right: 1px solid var(--sops-trans-white-border);
`;

const MainNavigationLayoutContainer = styled.div`
  max-width: 1400px;
`;

const MainNavigationLayoutContentWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  height: calc(100% - 90px);
`;

const MainNavigationLayoutContent = styled.main`
  width: ${(props) =>
    props.hideNavigation ? 'calc(100vw - 85px)' : 'calc(100vw - 385px)'};
  transform: translateX(${(props) => (props.hideNavigation ? '0' : '300px')});
  position: relative;
  transition: transform 0.2s ease-out 0s;
  padding-bottom: 10px;
  height: 100%;
  overflow-y: auto;
`;

const propTypes = {
  /** Pass the header content React element */
  headerContent: PropTypes.node,
  /** Pass the sidebar content React element */
  sideBarContent: PropTypes.node,
  /** Pass the main content React element */
  mainContent: PropTypes.node,
  /** Hide/show side navigation */
  toggleSideNavigation: PropTypes.bool
};

function MainNagivationLayout({
  headerContent,
  sideBarContent,
  mainContent,
  toggleSideNavigation = false
}) {
  return (
    <>
      <MainNavigationHeader>{headerContent}</MainNavigationHeader>
      <MainNavigationLayoutContentWrapper>
        <MainNavigationLayoutContainer>
          <MainNavigationLayoutSideBar hideNavigation={toggleSideNavigation}>
            {sideBarContent}
          </MainNavigationLayoutSideBar>
          <MainNavigationLayoutContent hideNavigation={toggleSideNavigation}>
            {mainContent}
          </MainNavigationLayoutContent>
        </MainNavigationLayoutContainer>
      </MainNavigationLayoutContentWrapper>
    </>
  );
}

MainNagivationLayout.propTypes = propTypes;

export default MainNagivationLayout;
